import Component from '../abstracts/Component';

export default class BackdropComponent extends Component {
  constructor(htmlEl) {
    super(htmlEl);
  }

  get CLASSES() {
    return {
      backdropShow: '--show',
      backdropThemePrefix: '--backdrop-theme-',
      bodyNoOverflow: '--no-overflow',
    };
  }

  /**
   * Applies styling fixed positioning and no overflow to body.
   * @param {string} [method='add'] - method to use on classList, default is 'add'.
   * @class HeaderComponent
   */
  applyGlobalStyling(method = 'add') {
    document.body.classList[method](this.CLASSES.bodyNoOverflow);
  }

  /**
   * Hides the backdrop by removing the `--show` class and emits the hide event.
   */
  closeBackdrop() {
    this.applyGlobalStyling('remove');
    this.$emit(this.$customEvents.BACKDROP_EVENTS.close);
  }

  /**
   * Clears all backdrop theme classes from the component.
   */
  clearBackdropThemes() {
    const classes = Array.from(this.$component.classList);
    classes.forEach((className) => {
      if (className.includes(this.CLASSES.backdropThemePrefix)) {
        this.$component.classList.remove(className);
      }
    });
  }

  /**
   * Binds event listeners for the backdrop component.
   */
  bindEvents() {
    this.$component.addEventListener('click', () => {
      this.closeBackdrop();
    });

    this.$on(this.$customEvents.BACKDROP_EVENTS.hide, () => {
      this.applyGlobalStyling('remove');
      this.$component.classList.remove(this.CLASSES.backdropShow);
      this.clearBackdropThemes();
    });

    this.$on(this.$customEvents.BACKDROP_EVENTS.show, (event) => {
      const backdropTheme = `${this.CLASSES.backdropThemePrefix}${event?.payload?.theme || 'default'}`;
      const disableGlobalOverflow =
        event?.payload?.disableGlobalOverflow || false;
      if (disableGlobalOverflow) this.applyGlobalStyling('add');
      this.clearBackdropThemes();
      this.$component.classList.add(this.CLASSES.backdropShow);
      if (backdropTheme) this.$component.classList.add(backdropTheme);
    });
  }

  /**
   * @inheritdoc
   * Binds event listeners after the component has been rendered.
   */
  render() {
    super.render();
    this.bindEvents();
  }
}
